require('../../../corporate-template/js/feature/text-image-spot.js');